import { useQuery } from "react-query";
import { getCoderQaAttributes } from "components/attributes/lib/attribute-data";
import { CodingSource } from "shared/taskTypeMap";

export const useAllCoderAttributes = (codingWipKey) => {
    return useQuery({
        queryKey: ["allCoderAttributes", codingWipKey],
        queryFn: () =>
            getCoderQaAttributes(codingWipKey).then((data) => {
                const roles = {};
                roles["Standard"] = [];
                roles["Detailed"] = [];
                roles.hasRedo = false;
                roles.subTaskKeys = [];
                data.map((r) => {
                    const role = r.taskType.split(".").pop();
                    const roleType = CodingSource[r.taskType];

                    if (r.taskState === "redo") {
                        roles.hasRedo = true;
                    }

                    if (roleType !== "coding") {
                        roles.subTaskKeys.push(r.taskKey);
                    }

                    //TODO: refactor when rows and groups are implemented
                    const lastUpdated = r.attributeValues["1880918225330826"];
                    const updatedBy = r.attributeValues["1880918225330825"];

                    if (roleType === "detailedcoding") {
                        return roles["Detailed"].push({
                            label: `Coder ${role.toUpperCase()}`,
                            taskLabel: "Detailed",
                            attributes: r.attributeValues,
                            lastUpdated: lastUpdated,
                            updatedBy: updatedBy,
                            type: role,
                            codingWipKey: r.codingWipKey,
                            taskKey: r.taskKey,
                            taskState: r.taskState,
                            taskType: r.taskType,
                            groupName: "CodingDetailedAttributes",
                        });
                    }

                    if (roleType === "coding") {
                        const qa = {
                            label: "QA Coder",
                            attributes: r.attributeValues,
                            lastUpdated: lastUpdated,
                            updatedBy: updatedBy,
                            codingWipKey: r.codingWipKey,
                            type: "qa",
                        };
                        roles["Standard"].push(qa);

                        return roles["Detailed"].push(qa);
                    }

                    return roles["Standard"].push({
                        label: `Coder ${role.toUpperCase()}`,
                        taskLabel: "Standard",
                        attributes: r.attributeValues,
                        lastUpdated: lastUpdated,
                        updatedBy: updatedBy,
                        type: role,
                        codingWipKey: r.codingWipKey,
                        taskKey: r.taskKey,
                        taskState: r.taskState,
                        taskType: r.taskType,
                        groupName: "CodingStandardAttributes",
                    });
                });

                return roles;
            }),
    });
};
